import cx from "classnames";
import React, { useEffect } from "react";
import styles from "./Login.module.scss";
import LoginQR from "./LoginQR";
import {
  cookiesPolicyGatacaUrl,
  documentationGataca,
  gaImages,
  helpUrl,
  legalNoticeGatacaUrl,
  marketAndroidLink,
  marketIosLink,
  gaColors,
  privacyPolicyGatacaUrl,
} from "../../assets/globalConstants";
import GaImage from "../../components/atoms/Image/Image";
import packageJson from "../../../package.json";
import { setSelectedRoute } from "../../store/navigation/navigationActions";
import { useDispatch } from "react-redux";
import { deleteSession } from "../../store/session/sessionActions";
import { history } from "../../services/history";
import Notification from "../../components/Notification/Notification";
import { useTranslation } from "react-i18next";

type ILoginProps = {};

const Login: React.FC<ILoginProps> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const goToLoginAndDeleteSession = () => {
    dispatch(setSelectedRoute("login"));
    dispatch(deleteSession());
    history.push("/login");
  };

  useEffect(() => {
    goToLoginAndDeleteSession();
    dispatch(setSelectedRoute("login"));
  }, []);

  return (
    <>
      <div className={styles.mainContainer}>
        <Notification />
        <section className={styles.infoSection}>
          <header>
            <GaImage image={gaImages?.gatacaLogo} />
          </header>
          <div className={styles.infoContainer}>
            <div>
              <GaImage image={gaImages?.unlockImg} />
            </div>
            <div className={styles.infoContainer__elements}>
              <div className={styles.header}>
                <h3 className={cx("heading3")}>
                  {t("login.headline")}{" "}
                  <span className={cx("heading3")}>
                    {t("login.headlineBrand")}
                  </span>{" "}
                  {t("login.account")}
                </h3>
              </div>
              <div className={styles.description}>
                <div className={styles.description__firstStep}>
                  <p>
                    <span className={cx("bodyBoldXL")}>1.</span>
                    <span className={cx("bodyRegularLG")}>
                      {t("login.subHeadline")}
                    </span>
                  </p>

                  <div className={styles.marketsContainer}>
                    <a
                      className={`${styles.marketButton}`}
                      href={marketAndroidLink}
                      target="_blank">
                      <GaImage image={gaImages?.googleBrandButtonIcon} />
                    </a>
                    <a
                      href={marketIosLink}
                      target="_blank"
                      className={`${styles.marketButton} ${cx(
                        "marginRight12"
                      )}`}>
                      <GaImage image={gaImages?.appleBrandButtonIcon} />
                    </a>
                  </div>
                </div>

                <p className={styles.scanStep}>
                  <span className={cx("bodyBoldXL")}>2.</span>
                  <span className={cx("bodyRegularLG")}>
                    {t("login.secondSubHeadline")}
                  </span>
                  <GaImage image={gaImages?.scanButtonIcon} />
                </p>
                <p className={cx("bodyBoldLG")}>
                  <span className={cx("bodyBoldXL")}>3.</span>
                  <span className={cx("bodyRegularLG")}>
                    {t("login.thirdSubHeadline")}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <footer className={`${styles.footer} ${styles.showDesktop}`}>
            <ul>
              <li className={cx("buttonMD")}>
                <a href={privacyPolicyGatacaUrl} target="_blank">
                  {t("login.privacyPolicy")}
                </a>
              </li>
              <li className={cx("buttonMD")}>
                <a href={cookiesPolicyGatacaUrl} target="_blank">
                  {t("login.cookiesPolicy")}
                </a>
              </li>
              <li className={cx("buttonMD")}>
                <a href={legalNoticeGatacaUrl} target="_blank">
                  {t("login.legalNotice")}
                </a>
              </li>
              <li className={cx("buttonMD")}>
                <a href={documentationGataca} target="_blank">
                  {t("login.documentation")}
                </a>
              </li>
            </ul>
          </footer>
        </section>
        <section className={styles.qrSection}>
          <div className={styles.qrSection__elements}>
            <div className={styles.main}>
              <LoginQR
                qrColor={gaColors.primaryColor}
                logoSrc={gaImages?.gatacaLogoIcon?.src}></LoginQR>
              <a className={cx("bodyRegularMD")} href={helpUrl} target="_blank">
                {t("login.help")}
              </a>
            </div>
            <div className={`${styles.version} ${styles.showDesktop}`}>
              <p className={cx("bodyRegularMD")}>
                {packageJson?.version && "v " + packageJson?.version}{" "}
              </p>
            </div>
          </div>
        </section>
        <footer className={`${styles.footer} ${styles.showMobile}`}>
          <ul>
            <li className={cx("buttonMD")}>
              <a href={privacyPolicyGatacaUrl} target="_blank">
                {t("login.privacyPolicy")}
              </a>
            </li>
            <li className={cx("buttonMD")}>
              <a href={cookiesPolicyGatacaUrl} target="_blank">
                {t("login.cookiesPolicy")}
              </a>
            </li>
            <li className={cx("buttonMD")}>
              <a href={legalNoticeGatacaUrl} target="_blank">
                {t("login.legalNotice")}
              </a>
            </li>
            <li className={cx("buttonMD")}>
              <a href={documentationGataca} target="_blank">
                {t("login.documentation")}
              </a>
            </li>
          </ul>

          <p className={`${cx("bodyRegularMD")} ${styles?.version}`}>
            {packageJson?.version && "v " + packageJson?.version}{" "}
          </p>
        </footer>
      </div>
    </>
  );
};

Login.defaultProps = {};

export default Login;
